import type { Command } from 'commander';
import { registerEnterpriseLogin } from './login';
import { registerEnterpriseLogout } from './logout';
import { registerEnterpriseWhoami } from './whoami';
import { registerEnterpriseUsage } from './usage';
import { registerEnterpriseJobsCommand } from './jobs';
import { registerEnterpriseKeysCommand } from './keys';
import { registerEnterpriseCompanyCommand } from './company';
import { registerEnterpriseTalentsCommand } from './talents';
import { registerEnterpriseCampaignsCommand } from './campaigns';

export function registerEnterpriseCommand(program: Command): void {
	const enterprise = program
		.command('enterprise')
		.description('Manage your company job postings with an enterprise API key')
		.option('--api-key <key>', 'one-off API key (prefer "wport enterprise login" or the WPORT_API_KEY env var)');
	registerEnterpriseLogin(enterprise);
	registerEnterpriseLogout(enterprise);
	registerEnterpriseWhoami(enterprise);
	registerEnterpriseUsage(enterprise);
	registerEnterpriseJobsCommand(enterprise);
	registerEnterpriseKeysCommand(enterprise);
	registerEnterpriseCompanyCommand(enterprise);
	registerEnterpriseTalentsCommand(enterprise);
	registerEnterpriseCampaignsCommand(enterprise);
}
